<span class="regular-link" (click)="openInvoices()" style="margin-bottom: 3px">
  [Invoices]
</span>
@if (canCollectCash()) {
  <span class="regular-link" (click)="addCash()" style="margin-bottom: 3px">
    <br/>
    [Collect Cash/Check]
  </span>
}
@if (canChargeCard()) {
  <span [ngClass]="workOrder.hasHourlyRateTask ? 'disabled-link' : 'regular-link'" (click)="chargeInvoice()">
    <br/>
    [Charge Credit Card]
  </span>
}
@if (canCloseOut()) {
  <span [ngClass]="workOrder.hasHourlyRateTask ? 'disabled-link' : 'regular-link'" (click)="finalize()">
    <br/>
    [Finalize and Mark Paid]
  </span>
}
@if (canCollectCash()) {
  <span (click)="resendInvoice()" style="margin-bottom: 3px" [ngClass]="isSending ? 'disabled-link' : 'regular-link'">
    <br/>
    [Resend Invoice]
  </span>
}

@if (nonPdfReceiptCount > 0 || pdfReceiptCount > 0) {
<span class="regular-link" (click)="openDialog()" style="margin-bottom: 3px">
  <br/>
  [View Receipts]
</span>
<span [ngClass]="isSending ? 'disabled-link' : 'regular-link'" (click)="sendReceiptsToCustomer()" style="margin-bottom: 3px;">
  <br/>
  [Email Receipt]
</span>
}

@if(nonPdfReceiptCount > 0) {
<span class="regular-link" (click)="openRefund()">
  <br/>
  [Refund]
</span>
}

@if(showReceipts) {
<div>
  <p-dialog header="Card Receipts" [(visible)]="showReceipts" [closable]="true" [style]="{width: '800px'}" [modal]="true"
    [baseZIndex]="11000" [responsive]="true" [resizable]="true" appendTo="body" (onHide)="closeDialog()">
    <!-- do an ngFor here so we can display mulitple recipts if need be -->
     @for(list of receiptList; track list) {
    <div style="width: 750px; margin-bottom: 6px;">
      <span>
        <button type="button" 
          class="btn btn-success receipt-button"  
          (click)="openNonPDFReceipts(list.receiptURLs)">
          {{ list.taskNames != "" ? list.taskNames + ' ' + list.invoiceNumber : 'View Task' + ' ' + list.invoiceNumber }}
        </button> 
      </span>
    </div>
  }
  </p-dialog>
</div>
}